import handleQueryError from '../../../../util/Common/Error/Handler/handleQueryError';
import safetyITTabletDefaultAPI from '../api';

const postITTablet = async ({ data }) => {
  try {
    const response = await safetyITTabletDefaultAPI.post('', data);
    return response;
  } catch (error) {
    throw new Error(handleQueryError({ error }));
  }
};

export default postITTablet;
